import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import OnePager from "pages/OnePager";
import DigitalMarketing from "./DigitalMarketing";
import FeeCollectionProcess from "./FeeCollectionProcess";
import AiPoweredManagmentHub from "./AiPoweredManagmentHub";
import CustomerSatisfaction from "./CustomerSatisfaction";
import Privacy from "./Privacy";
import Modal from "components/Modal";
import AfterSubmitionModal from "components/Modal/AfterSubmitionModal";
import PaymentPage from "components/PaymentPage";
import * as ModalR from "react-modal";
import { Button } from "components/Button";
import RefundPolicy from "./RefundPolicy";
import TermsOfService from "./TermsOfService";
import WhatsappCampaignForm from "components/WhatsappCampaign/WhatsappCampaignForm";
import OldOnboardingFlowRoute from "pages/OldOnboarding/SFR";
import SFR from "./SFR";
import { AppProvider } from "state";
import TextGen from "pages/SoomuchDemo/TextGen";
import CheckoutLiveWebsite from "pages/SoomuchDemo/CheckoutLiveWebsite";
import PhotoEnhancement from "pages/SoomuchDemo/PhotoEnhancement";
// import { SpotlightTour } from 'react-spotlight-tour';
// import Spotlight from 'react-spotlight-tour/spotlight';
import { SpotlightTour } from "pages/SoomuchDemo/components/SpotLight";
import Spotlight from "pages/SoomuchDemo/components/SpotLight/spotlight";
import Chatbot from "pages/SoomuchDemo/Chatbot";
import Communication from "pages/SoomuchDemo/Communication";
import Intro from "pages/SoomuchDemo/Intro";
import AiWebsite from "pages/SoomuchDemo/AiWebsite";
import ParentRefferals from "pages/SoomuchDemo/ParentRefferals";
import SocialHub from "pages/SoomuchDemo/SocialHub";
import CommPage2 from "pages/SoomuchDemo/Communication/CommPage2";
import CommPage3 from "pages/SoomuchDemo/Communication/CommPage3";
import SchoolManagment from "pages/SoomuchDemo/SchoolManagment";
import HomeWork from "pages/SoomuchDemo/HomeWork";
import { GlobalStateProvider } from "components/GlobalState";
import DisableRightClick from "components/DisableRightClick";
import HowToAchive from "pages/SoomuchDemo/HowToAchive";
import SocialHubBoostEngagement from "pages/SoomuchDemo/SocialHub/SocialHubBoostEngagement";
import DummyCommunication from "pages/SoomuchDemo/Communication/DummyCommunication";
import HomeworkTrack from "./HomeworkTrack";
import AttendanceTrack from "./AttendanceTrack";
import NewCheckout from "pages/SoomuchDemo/CheckoutLiveWebsite/NewCheckout";
import NewFaculties from "pages/Onboarding/Faculties/NewFaculties";
import MetaAuth from "components/MetaAuth";
import NewGoogleAuth from "components/GoogleAuth/NewGoogleAuth";
import { ModalProvider } from "components/GlobalModal";
import NewLandingPage from "./NewLandingPage";
import NLP from "../NewLandingPage";
import { ImgComponent } from "components/Img/ImgComponent";
import RefundAndCancel from "./RefundAndCancel";
import NavigationProvider from "components/NavigationProvider";
import AboutUs from "pages/NewLandingPage/NewHeroSection/AboutUs";
import Footer from "pages/NewLandingPage/NewHeroSection/AvatarWebinar/Footer";
import ContactUs from "pages/NewLandingPage/NewHeroSection/ContactUs";
import AvatarWhatsapp from "pages/NewLandingPage/NewHeroSection/AvatarWhatsapp";
import NewHeader from 'pages/NewLandingPage/NewHeroSection/components/Header';
import AvatarIDCards from "pages/NewLandingPage/NewHeroSection/AvatarIDCards";
import AvatarStartup from "pages/NewLandingPage/NewHeroSection/AvatarStrartup";
// import AvatarDigitalMarketer from "pages/NewLandingPage/NewHeroSection/AvatarDigitalMarketer";
// import AvatarTeacher from "pages/NewLandingPage/NewHeroSection/AvatarTeacher";
// import AvatarSupport from "pages/NewLandingPage/NewHeroSection/AvatarSupport";
// import AvatarOperator from "pages/NewLandingPage/NewHeroSection/AvatarOperator";
import StickyHeader from "pages/NewLandingPage/NewHeroSection/components/StickyHeader";
import { PATH } from "utils";
import NotFound from "./NotFound";
const NewOnboarding = lazy(() => import("pages/NewOnboarding"));
const SoomuchOnboardingPhase2 = lazy(
  () => import("pages/NewOnboarding/phase2/SoomuchOnboardingPhase2"),
);
const SoomuchOnboardingPhase3 = lazy(
  () => import("pages/NewOnboarding/phase3/SoomuchOnboardingPhase3"),
);
const SoomuchOnboardingPhase4 = lazy(
  () => import("pages/NewOnboarding/phase4/SoomuchOnboardingPhase4"),
);
// import ZohoOptinWrapper from "components/Zoho/ZohoOptinWrapper";

const customStylesRefer = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "55rem", // Adjusted for responsiveness
    maxWidth: "90%", // Added to maintain a max width
    minHeight: "6rem",
    borderRadius: "1em",
    boxShadow: "0px 16px 32px 4px rgba(0, 0, 0, 0.15)",
    padding: "0px",
    border: "0px",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.4)",
    zIndex: "999",
  },
  "@media (min-width: 768px)": {
    content: {
      width: "75%", // Adjusted for tablet view
    },
  },
  "@media (min-width: 1024px)": {
    content: {
      width: "55rem", // Original width for desktop view
    },
  },
};

const customStylesAskModal = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "30rem",
    maxWidth: "80%",
    minHeight: "10rem",
    borderRadius: "1.5em",
    boxShadow: "0px 16px 32px 4px rgba(0, 0, 0, 0.15)",
    padding: "1.3em",
  },
  overlay: {
    background: "rgba(0, 0, 0, 0.4)",
    zIndex: 999,
  },
};

const SOURCE_NAME = {
  "/": "COMM",
  "/customer-satisfaction": "FEEDBACK",
  "/fee-collection-process": "FEE",
};

function generateUniqueKey(length = 10) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let uniqueKey = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    uniqueKey += characters[randomIndex];
  }
  return uniqueKey;
}

export default function Main() {

  const [isScreenTooSmall, setIsScreenTooSmall] = React.useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      console.log("minimum window size 1024")
      console.log("current window size ", window.innerWidth)
      setIsScreenTooSmall(window.innerWidth < 1024);
    };

    checkScreenSize(); // initial check
    window.addEventListener('resize', checkScreenSize); // add resize listener

    return () => {
      window.removeEventListener('resize', checkScreenSize); // clean up
    };
  }, []);

  const [isOpen, setOpen] = React.useState(true);
  const [bookFormModal, setbookFormModal] = React.useState<{
    display: boolean;
    ID: number | undefined;
  }>({ display: false, ID: undefined });
  const [formSuccessModal, setFormSuccessModal] = React.useState<{
    display: boolean;
    ID: number | undefined;
  }>({ display: false, ID: undefined });
  const [reRequestLiveDemo, setReRequestLiveDemo] = React.useState<{
    display: boolean;
    ID: number | undefined;
  }>({ display: false, ID: undefined });

  let demoData: any = "";

  try {
    demoData = JSON.parse(localStorage.getItem("demo_data")) || "";
  } catch (err) {
    console.log("err ", err);
  }

  const handleReRequestLiveDemo = async () => {
    localStorage.setItem(
      "demo_data",
      JSON.stringify({
        ...demoData,
        SOURCE_ARRAY: !!demoData?.SOURCE_ARRAY?.length
          ? [
            ...demoData?.SOURCE_ARRAY,
            SOURCE_NAME?.[window?.location?.pathname],
          ]
          : [demoData?.SOURCE, SOURCE_NAME?.[window?.location?.pathname]],
      })
    );
    // const campaginDetailResponse = await axios.post(
    //   `${API_HOST}/master/demoCampaignDetail/insert`,
    //   {
    //     ...demoData,
    //     SOURCE: SOURCE_NAME?.[window?.location?.pathname],
    //   }
    // );
    handleSuccessModal({ display: false, ID: 0 });
  };

  const handleModal = async () => {
    if (demoData?.DEMO_CAMPAIGN_ID) {
      if (
        demoData?.SOURCE === SOURCE_NAME?.[window?.location?.pathname] ||
        demoData?.SOURCE_ARRAY?.includes(
          SOURCE_NAME?.[window?.location?.pathname]
        )
      ) {
        setReRequestLiveDemo({ display: true, ID: 0 });
      } else {
        handleReRequestLiveDemo();
      }
    } else {
      setbookFormModal({ display: true, ID: 0 });
    }
  };

  const handleSuccessModal = (e) => {
    setbookFormModal(e);
    setFormSuccessModal({ display: true, ID: 0 });
  };

  useEffect(() => {
    // Generate a unique identifier for the session
    const sessionKey = "sessionKey";
    const sessionValue = generateUniqueKey();

    if (
      sessionStorage.getItem(sessionKey) !== localStorage.getItem(sessionKey)
    ) {
      localStorage.clear();
      sessionStorage.clear();
    }
    // Set the session value if it's not already set
    if (!sessionStorage.getItem(sessionKey)) {
      sessionStorage.setItem(sessionKey, sessionValue);
    }
    if (!localStorage.getItem(sessionKey)) {
      localStorage.setItem(sessionKey, sessionValue);
    }
    const handleBeforeUnload = (event) => {
      // If the session storage does not have the session key, it's a tab close event
      if (!sessionStorage.getItem(sessionKey)) {
        localStorage.clear();
        sessionStorage.clear();
      }

      // Optionally, you can show a confirmation message
      event.returnValue = ""; // This line is necessary for some browsers to show a confirmation dialog
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  function ConditionalRoutes() {
    const location = useLocation();

    // Check if the path starts with "/old/onboarding"
    const isOldOnboarding = location.pathname.startsWith("/old/onboarding");
    const isNewOnboarding = location.pathname.startsWith("/new-onboarding");
    const isOnboarding = location.pathname.startsWith("/onboarding");
    const demoWebsite = location.pathname.startsWith("/explore");
    const v1 = location.pathname.startsWith("/v1");
    const v2 = location.pathname.startsWith("/v2");
    if (isOldOnboarding) {
      return (
        <Routes>
          <Route path="/old/onboarding" element={<Navigate to="/old/onboarding/instituteInfo" replace />} />
          <Route
            path="/old/onboarding/*"
            element={<OldOnboardingFlowRoute />}
          />
        </Routes>
      );
    } else if (isNewOnboarding) {
      return (
        <Suspense fallback={<div className="min-h-screen bg-[#f7f8fc]" />}>
          <Routes>
            <Route path="/new-onboarding/phase-2/*" element={<SoomuchOnboardingPhase2 />} />
            <Route path="/new-onboarding/phase-3/*" element={<SoomuchOnboardingPhase3 />} />
            <Route path="/new-onboarding/phase-4/*" element={<SoomuchOnboardingPhase4 />} />
            <Route
              path="/new-onboarding/*"
              element={
                <AppProvider>
                  <NewOnboarding />
                </AppProvider>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      );
    } else if (isOnboarding) {
      return (
        <ModalProvider>
          <AppProvider>
            <Routes>
              <Route path="/onboarding/*" element={<SFR />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </AppProvider>
        </ModalProvider>
      );
    } else if (demoWebsite) {
      return (
        !isScreenTooSmall ? <GlobalStateProvider>
          <DisableRightClick>
            <Routes>
              <Route path="/explore" element={<Intro />} />
              <Route path="/explore/how-to-achive" element={<HowToAchive />} />
              <Route path="/explore/communication/poor-comm" element={<CommPage2 />} />
              <Route path="/explore/communication/the-solution" element={<CommPage3 />} />
              <Route path="/explore/communication/communication-id" element={<Communication />} />
              <Route path="/explore/communication" element={<DummyCommunication />} />
              <Route path="/explore/social-hub/stay-ahead-with-ai" element={<SocialHub />} />
              <Route path="/explore/social-hub/social-hub-boost-engagement" element={<SocialHubBoostEngagement />} />
              <Route path="/explore/website/launch-website" element={<AiWebsite />} />
              <Route path="/explore/chatbot" element={<Chatbot />} />
              <Route path="/explore/website/image-enhancement" element={<PhotoEnhancement />} />
              <Route path="/explore/website/text-generator" element={<TextGen />} />
              <Route path="/explore/benefits/parent-referrals" element={<ParentRefferals />} />
              <Route path="/explore/benefits/school-managment" element={<SchoolManagment />} />
              <Route path="/explore/benefits/homework" element={<HomeWork />} />
              <Route path="/explore/checkout-live-website2" element={<CheckoutLiveWebsite />} />
              <Route path="/explore/checkout-live-website" element={<NewCheckout />} />
            </Routes>
          </DisableRightClick>
        </GlobalStateProvider> : <>
          <div className="flex justify-center items-center w-screen h-screen bg-[#F9F9F9]">
            <ImgComponent src="images/soomuch-demo/Desktop.svg" alt="close" className="h-full object-cover" />
          </div>
        </>
      );
    } else if (v1) {
      return (
        <>
          <Routes>
            {/*  <Route
          path="/v2"
          element={<NewLandingPage />}
        /> */}
            <Route
              path="/v1"
              element={<NewLandingPage />}
            />
            <Route path="/v1/demopayment" element={<PaymentPage />} />
            <Route path="/v1/privacy-policy" element={<Privacy />} />
            <Route path="/v1/terms-of-service" element={<TermsOfService />} />
            <Route path="/v1/refund-policy" element={<RefundPolicy />} />
            <Route path="/v1/demo-whatsapp-campaign" element={<WhatsappCampaignForm />} />
            <Route path="/v1/hw_track" element={<HomeworkTrack />} />
            <Route path="/v1/att_track" element={<AttendanceTrack />} />
            <Route path='/google/*' element={<NewGoogleAuth />} />
            <Route
              path="/meta_auth/*"
              element={
                <MetaAuth
                // handleNavigate={handleNavigate}
                // resetFormData={resetFormData}
                />
              }
            />
          </Routes>
        </>
      );
    } else if (v2) {
      return <Routes>
        {/* <Route path={PATH_FOR_DIGITAL_MARKETING} element={<div className="bg-[#FCFAFF]" style={{ position: "relative", zIndex: 1 }}>
          <NewHeader />
          <AvatarDigitalMarketer />
          <Footer marginTop='mt-0' />
        </div>} />
        <Route path={PATH_FOR_TEACHER} element={<div className="bg-[#FCFAFF]" style={{ position: "relative", zIndex: 1 }}>
          <NewHeader />
          <AvatarTeacher />
          <Footer marginTop='mt-0' />
        </div>} />
        <Route path={PATH_FOR_AI_SUPPORT} element={<div className="bg-[#FCFAFF]" style={{ position: "relative", zIndex: 1 }}>
          <NewHeader />
          <AvatarSupport />
          <Footer marginTop='mt-0' />
        </div>} />
        <Route path={PATH_FOR_OPERATOR} element={<div className="bg-[#FCFAFF]" style={{ position: "relative", zIndex: 1 }}>
          <NewHeader />
          <AvatarOperator />
          <Footer marginTop='mt-0' />
        </div>} /> */}
        <Route path={PATH.PATH_FOR_STARTUP} element={<div className="bg-[#FCFAFF]" style={{ position: "relative", zIndex: 1 }}>
          <div className="relative">
            <div className="fixed top-0 left-0 z-50 w-full bg-[white] shadow-md">
              <NewHeader usePrefix={true} />
              <StickyHeader
                showWhen="always"
              />
            </div>
          </div>
          <AvatarStartup />
          <Footer marginTop='mt-0' />
        </div>} />
        <Route path={PATH.PATH_FOR_WHATSAPP} element={<div className="bg-[#FCFAFF]" style={{ position: "relative", zIndex: 1 }}>
          <div className="relative">
            <div className="fixed top-0 left-0 z-50 w-full bg-[white] shadow-md">
              <NewHeader usePrefix={true} />
              <StickyHeader
                showWhen="always"
              />
            </div>
          </div>
          <AvatarWhatsapp />
          <Footer marginTop='mt-0' />
        </div>} />
        <Route path={PATH.PATH_FOR_ID_CARDS} element={<div className="bg-[#FCFAFF]" style={{ position: "relative", zIndex: 1 }}>
          <div className="relative">
            <div className="fixed top-0 left-0 z-50 w-full bg-[#FCFAFF] shadow-md">
              <NewHeader usePrefix={true} />
              <StickyHeader
                showWhen="always"
              />
            </div>
          </div>
          <AvatarIDCards />
          <Footer marginTop='mt-0' />
        </div>} />
        <Route path={PATH.PATH_FOR_ABOUT_US} element={<div className="bg-[#FCFAFF]" style={{ position: "relative", zIndex: 1 }}>
          <NewHeader usePrefix={true} />
          <AboutUs />
          <Footer />
        </div>} />
        <Route path={PATH.PATH_FOR_CONTACT_US} element={<div className="bg-[#FCFAFF]" style={{ position: "relative", zIndex: 1 }}>
          <NewHeader usePrefix={true} />
          <ContactUs />
          <Footer marginTop='mt-0' />
        </div>} />
        <Route path={PATH.PATH_FOR_ALL} element={<NLP />} />
      </Routes>
    }

    return (
      <>
        {location.pathname !== "/" && !["meta_auth", "google"].includes(location.pathname?.split("/")?.[1]) && <Header />}
        <Routes>
          <Route path='/google/*' element={<NewGoogleAuth />} />
          <Route
            path="/meta_auth/*"
            element={
              <MetaAuth
              // handleNavigate={handleNavigate}
              // resetFormData={resetFormData}
              />
            }
          />
          <Route
            path="/"
            element={<OnePager />}
          />
          <Route path="/digital-marketing" element={<DigitalMarketing handleModal={handleModal} />} />
          <Route path="/customer-satisfaction" element={<CustomerSatisfaction handleModal={handleModal} />} />
          <Route path="/fee-collection-process" element={<FeeCollectionProcess handleModal={handleModal} />} />
          <Route path="/ai-powered-managment-hub" element={<AiPoweredManagmentHub handleModal={handleModal} />} />
          <Route path="/demopayment" element={<PaymentPage />} />
          <Route path="/privacy-policy" element={<Privacy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundAndCancel />} />
          <Route path="/demo-whatsapp-campaign" element={<WhatsappCampaignForm />} />
          <Route path="/hw_track" element={<HomeworkTrack />} />
          <Route path="/att_track" element={<AttendanceTrack />} />
          <Route path="/NewFaculty" element={<NewFaculties />} />
        </Routes>
        {/* <ZohoOptinWrapper /> */}
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>
          Soomuch{/* Revolutionize Education with Our Ecosystem  */}
          {/* - AUTO CONNECT */}
        </title>
        <meta
          name="description"
          content="Discover India's first business ecosystem tailored for educational institutions. Enhance communication, streamline fee collection, and boost digital marketing with AUTO CONNECT. Book a live demo today."
        />
      </Helmet>
      {reRequestLiveDemo.display && (
        <ModalR
          isOpen={reRequestLiveDemo.display}
          contentLabel="Example Modal"
          style={customStylesAskModal}
        >
          <div className="flex justify-between">
            <h1 className="font-bold text-xl">Confirmation</h1>
            <button
              onClick={() => setReRequestLiveDemo({ display: false, ID: 0 })}
            >
              <ImgComponent src="/images/Close.svg" alt="close" className="h-8" />
            </button>
          </div>
          <p className="text-medium text-md text-neutral-70 my-[1.5em]">
            The demo for this module has already been completed. Are you sure
            you want to proceed with another demonstration?
          </p>
          <div className="flex justify-end">
            <div className="flex gap-2">
              <Button
                size="sm"
                type="button"
                className="font-semibold rounded-lg"
                onClick={() => {
                  setReRequestLiveDemo({ display: false, ID: 0 });
                }}
              >
                No
              </Button>
              <Button
                onClick={() => {
                  setReRequestLiveDemo({ display: false, ID: 0 });
                  handleReRequestLiveDemo();
                }}
                type="button"
                size="sm"
                color="deep_purple_400_red_500"
                className="!bg-gradient font-semibold rounded-lg"
              >
                Yes
              </Button>
            </div>
          </div>
        </ModalR>
      )}
      {formSuccessModal?.display && (
        <AfterSubmitionModal
          customStyles={customStylesRefer}
          showModal={formSuccessModal}
          setshowModal={(e) => setFormSuccessModal(e)}
        />
      )}
      {bookFormModal?.display && (
        <Modal
          customStyles={customStylesRefer}
          showModal={bookFormModal}
          setshowModal={(e) => setbookFormModal(e)}
          handleSuccessModal={(e) => handleSuccessModal(e)}
        />
      )}
      <div
        className={`bg-white-A700_01 relative ${
          window.location.pathname.startsWith("/new-onboarding")
            ? "h-screen overflow-hidden"
            : window.location.pathname === "/"
              ? ""
              : "space-y-[110px] overflow-x-hidden"
        }`}
        style={
          window.location.pathname.startsWith("/new-onboarding")
            ? { width: "100vw", height: "100dvh", overflow: "hidden" }
            : window.location.pathname === "/"
              ? { overflowX: "clip" as const }
              : undefined
        }
      >
        <SpotlightTour
          open={isOpen}
          onClose={() => setOpen(false)}
          Spotlight={Spotlight}
        >
          <BrowserRouter>
            <NavigationProvider />
            {/* <ZohoChat /> */}
            <ConditionalRoutes />
          </BrowserRouter>
        </SpotlightTour>
      </div>
    </>
  );
}
